import { AddLayerObject, ExpressionSpecification } from 'maplibre-gl';

import {
  AcresMapboxLayerIds,
  AcresMapboxVectorSourceLayerIds,
} from '../../../mapbox-layers';

const getEffectiveDate: ExpressionSpecification = ['get', 'eff_date'];
const getFirmPan: ExpressionSpecification = ['get', 'firm_pan'];

export const floodMetaLabelsLayer = (
  tileSourceUrl: string
): AddLayerObject => ({
  id: AcresMapboxLayerIds.FLOOD_META_LABELS,
  layout: {
    'symbol-placement': 'point',
    'text-allow-overlap': false,
    'text-field': [
      'concat',
      getFirmPan,
      '\n',
      [
        'concat',
        'eff. ',
        ['slice', getEffectiveDate, 5, 7], // MM
        '/',
        ['slice', getEffectiveDate, 8, 10], // DD
        '/',
        ['slice', getEffectiveDate, 0, 4], // YYYY
      ],
    ],
    'text-font': ['Roboto Regular', 'Arial Unicode MS Bold'],
    'text-ignore-placement': false,
  },
  maxzoom: 22,
  minzoom: 10,
  paint: {
    'text-color': '#12171C',
    'text-halo-color': 'white',
    'text-halo-width': 2,
  },
  source: {
    maxzoom: 22,
    minzoom: 10,
    tiles: [`${tileSourceUrl}{z}/{x}/{y}`],
    type: 'vector',
  },
  'source-layer': AcresMapboxVectorSourceLayerIds.FLOOD_META_LABELS,
  type: 'symbol',
});

export const floodMetaLabelsFillLayer = (
  tileSourceUrl: string
): AddLayerObject => ({
  id: AcresMapboxLayerIds.FLOOD_LABELS_FILL,
  layout: {
    visibility: 'visible',
  },
  maxzoom: 22,
  minzoom: 10,
  paint: {
    'line-color': 'white',
    'line-opacity': 1,
    'line-width': 3,
  },
  source: {
    maxzoom: 22,
    minzoom: 10,
    tiles: [`${tileSourceUrl}{z}/{x}/{y}`],
    type: 'vector',
  },
  'source-layer': AcresMapboxVectorSourceLayerIds.FLOOD_META_LABELS,
  type: 'line',
});
